import { useMemo, useState, useEffect, Dispatch, SetStateAction } from 'react';
import { IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';

export const useDataSource = <TInput>(
	results: any,
	setResults: Dispatch<SetStateAction<any>>,
	handleSearch: (criteria: Partial<TInput>) => void,
) => {
	const [dataGridParams, setDataGridParams] = useState<IServerSideGetRowsParams | null>(null);

	const serverSideDataSource: IServerSideDatasource = useMemo(
		() => ({
			getRows: (gridParams: IServerSideGetRowsParams) => {
				const { sortModel } = gridParams.request;

				const currentPage = gridParams.api.paginationGetCurrentPage() + 1;
				const pageSize = gridParams.api.paginationGetPageSize();

				const sortColumn = sortModel.length > 0 ? sortModel[0].colId : ''; // Only support 1 column sorting (for now)
				const sortDescending = sortModel.length > 0 ? sortModel[0].sort === 'desc' : false;

				const searchCriteria = {
					page: currentPage,
					pageSize,
					sortOrder: sortColumn,
					isSortDescending: sortDescending,
				} as unknown as Partial<TInput>;
				setDataGridParams(gridParams);
				handleSearch(searchCriteria);
			},
		}),
		[handleSearch],
	);

	useEffect(() => {
		if (dataGridParams) {
			dataGridParams.api?.setGridOption('loading', results.loading);

			if (results.data && !results.loading) {
				const rowData = results.data.results ?? [];
				const rowCount = results.data.totalResults ?? 0;

				dataGridParams.success({
					rowData: rowData,
					rowCount: rowCount,
				});

				if (rowData.length === 0) {
					dataGridParams.api.showNoRowsOverlay();
				}
			} else if (results.error && !results.loading && dataGridParams) {
				dataGridParams.fail();
			}
		}
	}, [results.data, results.loading, results.error, dataGridParams]);

	return serverSideDataSource;
};
